import React, { useState, useEffect } from "react";
import { Checkbox } from 'primereact/checkbox';
import './RoleTile.css';
import { ToggleButton } from 'primereact/togglebutton';
import { Button } from "primereact/button";
import { ajoutRole, enleveRole } from "../redux/partieSlice";
import { useDispatch } from "react-redux";





function input(isNumber, onCheckboxChange, id) {
    if (isNumber)
        return <input name="rolecheck" type="number" min="0" max="30" />
    else
        return <Checkbox inputId={id} onChange={(e) => { onCheckboxChange(e.target.checked, id); }} />
}



export default function RoleTile({ role, checked, onCheckboxChange }) {

    const [active, setActive] = useState(checked);
    const dispatch = useDispatch()

    useEffect(() => {
        setActive(checked);
    }, [checked]);

    const handleClick = () => {
        const newState = !active;
        setActive(newState);
        if (newState) dispatch(ajoutRole(role))
        else dispatch(enleveRole(role.order))
    };

    const handleImageError = (e) => {
        e.target.src = `${process.env.REACT_APP_WEREWOLVES_API_URL}/${process.env.REACT_APP_FOLDER_IMAGES}/role/default.png`;
    };

    return (
        <Button className={`roleTile ${active ? 'active' : ''}`} onClick={handleClick}>
            <img className="imgroletile" src={`${process.env.REACT_APP_WEREWOLVES_API_URL}/${process.env.REACT_APP_FOLDER_IMAGES}/role/${role.imageName ?? 'default'}.png`} onError={handleImageError} width="50px" height="50px" />
            <label >{role.name}</label>
        </Button>

    );
}